import _objectSpread from '@babel/runtime/helpers/objectSpread2';

var _icons = {};
var count = 0;
/** Add icons to library to be used for rendering using name.
This needs to be done lonly once */
var add = function add(icons) {
  _icons = _objectSpread(_objectSpread({}, _icons), icons);
};
var get = function get(name) {
  count += 1;
  return {
    icon: _icons[name],
    count: count
  };
};

export { add, get };
